//@flow
import * as React from 'react'
import type { TheiaQualityReview$Props } from './flowTypes'
import ContainerRowExpandPanel from '../../components/common/ContainerRowExpandPanel'
import QualityReviewContainer from '../../components/QualityReview/QualityReviewContainer'

const TheiaQualityReview=(props:TheiaQualityReview$Props)=>{
    const theia = props.theia
    let isVisible = false

    if (theia.reviewQuestions && theia.reviewQuestions.length > 0){
        isVisible = true
    }
    
    return (
        <ContainerRowExpandPanel visible={isVisible} 
        title={'Final Review Before Submission'} elementId={'theiaQualityReview'} 
        errors={props.noOfErros}
        >
            <QualityReviewContainer 
                elementId={'theiaPanelReviewQuestion'} 
                changeFieldValue={props.changeFieldValue} 
                questions={(theia.reviewQuestions:any)} 
            />
        </ContainerRowExpandPanel>
    )
}

export default TheiaQualityReview


// WEBPACK FOOTER //
// ./src/views/ProjectTheia/TheiaQualityReview.js